import { Exception } from '@core/exceptions/exception';

export class ActivationTokenExpiredException extends Exception {
  constructor(message = 'Token expired.') {
    super(message);
  }
}
